const style = (theme) => {
  const output = {
    luigi: {
      width: 100,
      height: 100,
    },
    root: {
      overflow: 'hidden',
      position: 'relative',
      paddingTop: 0,
      '& h4': {
        fontSize: 16,
        fontWeight: 500,
        marginBottom: 25,
      },
    },
    container: {
      extend: theme.wrapper,
      margin: '0 auto',
      position: 'relative',
      zIndex: 1,
    },
    wrapper: {
      paddingBottom: 100,
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    },
    footerTop: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '& div': {
        '& h2': {
          fontSize: 67,
          fontFamily: theme.fonts[0],
          fontWeight: 500,
          lineHeight: 1,
          color: theme.colors[0],
          textTransform: 'uppercase',
          '& strong': {
            fontFamily: theme.fonts[1],
            fontWeight: 'normal',
          },
        },
        '& p': {
          margin: 0,
          marginTop: 50,
          width: '40%',
          fontWeight: 400,
          '& strong': {
            fontWeight: 700,
          },
        },
      },
    },
    footerTopSpiral: {
      marginRight: 100,
      width: 300,
      height: 300,
      transform: 'rotate(-25deg)',
    },
    footerBottom: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      fontSize: 16,
      fontWeight: 400,
      gap: 100,
    },
    footerLeft: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      gap: 20,
      '& > p': {
        margin: 0,
      },
    },
    iscriviti: {
      width: 'fit-content',
      padding: '25px 50px',
      color: theme.colors[1],
      fontSize: 16,
      '&::after': {
        backgroundColor: theme.colors[3],
        width: '100%',
        height: '100%',
        borderRadius: 60,
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 0,
      },
    },
    legals: {
      display: 'block',
      textDecoration: 'none',
      color: theme.colors[0],
      transition: 'all 0.5s ease',
      '@media (hover: hover)': {
        '&:hover': {
          opacity: 0.7,
        },
      },
    },
    footerRight: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      minWidth: 180,
      gap: 20,
      '& p:first-child': {
        textTransform: 'uppercase',
        margin: 0,
      },
      '& p:nth-child(2)': {
        marginTop: 25,
      },
    },
    email: {
      color: theme.colors[3],
      transition: 'all 0.5s ease',
      '@media (hover: hover)': {
        '&:hover': {
          opacity: 0.7,
        },
      },
    },
    footerBottomMobile: {
      display: 'none',
    },
    footerBottomSpiral: {},
    voicesMenuFooter: {},
    spessoreCenter: {
      minHeight: 115,
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {}

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    root: {
      // paddingTop: 60,
      '&::before': {
        height: 70,
      },
    },
    wrapper: {
      paddingBottom: 30,
    },
    // wrapper: {
    //   flexDirection: 'column',
    //   textAlign: 'center',
    //   '& > *:not(:last-child)': {
    //     marginBottom: 20,
    //   },
    // },
    // footerText: {
    //   marginTop: 10,
    // },
    // certification: {
    //   '& > *': {
    //     marginLeft: 'auto',
    //     marginRight: 'auto',
    //   },
    // },
    footerTop: {
      '& div': {
        '& h2': {
          fontSize: 36,
        },
        '& p': {
          marginTop: 50,
          width: '100%',
        },
      },
    },
    footerTopSpiral: {
      display: 'none',
    },
    footerBottom: {
      display: 'block',
      marginTop: 35,
    },
    footerLeft: {
      display: 'block',
      '& > p': {
        display: 'none',
      },
    },
    footerCenter: {
      marginTop: 80,
    },
    footerRight: {
      marginTop: 80,
      display: 'block',
    },
    footerBottomMobile: {
      display: 'block',
      width: '100%',
      marginTop: 30,
      '& p': {
        fontSize: 16,
        marginTop: 50,
        marginBottom: 0,
      },
    },
    footerBottomSpiral: {
      width: 200,
      height: 200,
      transform: 'rotate(-25deg)',
    },
    voicesMenuFooter: {
      marginBottom: 5,
    },
    spessoreCenter: {
      minHeight: 0,
    },
  }

  return output
}

export default style
